import React, {Component} from 'react';
import {Button, Modal, Form} from 'semantic-ui-react';
import SimpleTable from "../extras/SimpleTable";
import QuestionDialog from "../extras/QuestionDialog";
import SalePaymentData from "../../data/SalePaymentData";
import connect from "react-redux/es/connect/connect";
import {simpleTableAddOrUpdate, simpleTableDelete} from "../../actions/SimpleTableDataActions";
import {showToast} from "../../actions/ToastAction";
import {paymentsDialog} from "../../actions/PaymentsDialogActions";
import {totalSale} from "../../actions/SaleTotalAction";
import c from "../../constants";
import update from "react-addons-update";
import localDB from "../../data/localDB";
import MaskedInput from 'react-text-mask';
import createNumberMask from "text-mask-addons/dist/createNumberMask";

const moneyMask = createNumberMask({
    prefix: '$',
});

class Payments extends Component {

    constructor(props) {
        super(props);
        this.state = {
            table_payments: {
                headers: ['Fecha y Hora', 'Medio de Pago', 'Valor', 'Acciones'],
                title: 'Pagos Realizados',
                url: `sales-payment/${props.sale.id}`,
                values: ['id', 'payment', 'date', 'type_display'],
                money_fields: ['payment'],
                datetime_fields: ['date'],
                id: 'table_payments',
                has_actions: true,
                edit: this.canEdit(),
                delete: this.canEdit()
            },
            data: {
                id: props.sale.id,
                amount: 0,
                type: null,
                type_display: null
            },
            sale: props.sale,
            open_edit: false,
            payment_error: false,
            sending_payment: false
        };

        this.handlePaymentChange = this.handlePaymentChange.bind(this);
    }

    canEdit = () => {
        if(this.props.sale.state === 1){
            return true;
        }else if(this.props.sale.state !== 1 && localDB.get('rol_access').includes('sale_edit_after_close')){
            return true;
        }
    };

    handleCloseEdite = () => {
        this.setState({open_edit: false});
    };

    callbackPaymentTable = (response) =>{
        if(response.event === 'edit'){
            this.setState({data: response.data});
            this.setState({open_edit: true});
        }else if(response.event === 'delete'){
            this.refs.delete_payment.open('', response.data.id);
        }
    };

    deletePayment = (id) => {
        SalePaymentData.delete(id, (res) => {
            if (res.delete) {
                this.props.simpleTableDelete(id);
                this.props.totalSale(res.data);
                this.props.showToast({message: 'Pago Borrado!', type: 'success'});
            } else {
                this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
            }
        }).catch(() => this.props.showToast({message: 'Tenemos un problema!', type: 'error'}));
    };

    handleClose = () => {
        this.props.paymentsDialog({open:false});
    };

    handlePaymentTypeChange = (result) => {
        let data = update(this.state, {
            data: {
                type: {
                    $set: result
                }
            }
        });
        this.setState(data);
    };

    handlePaymentChange = (event) => {
        let amount = isNaN(parseFloat(event.target.value.replace(/\D/g, ''))) ? '':parseFloat(event.target.value.replace(/\D/g, ''));
        let data = update(this.state, {
            data: {
                payment: {
                    $set: amount
                }
            }
        });
        this.setState(data);
        this.setState({payment_error:false})
    };

    handleSubmit = () =>{
        if(this.state.data.payment <= 0){
            this.setState({payment_error:true})
        }else {
            this.setState({sending_payment:true});
            SalePaymentData.update(this.state.data, res =>{
                if(res && res.update){
                    this.setState({open_edit:false});
                    this.props.simpleTableAddOrUpdate(res.data);
                    this.props.totalSale(res.payments);
                    this.props.showToast({message: 'Pago Actualizado!', type: 'success'});
                }else {
                    this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                }
            }).catch(()=> this.props.showToast({message: 'Tenemos un problema!', type: 'error'})).finally(() => this.setState({sending_payment:false}));
        }
    };

    render() {
        return (
            <div>
                <Modal size='small' dimmer='inverted' open={this.props.payments_dialog.open} onClose={this.handleClose}>
                    <Modal.Content scrolling>
                        <Modal.Description>
                            <SimpleTable {...this.state.table_payments} callbackDynamicTable={this.callbackPaymentTable}/>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Aceptar"/>
                    </Modal.Actions>
                </Modal>

                <Modal size='mini' dimmer='inverted' open={this.state.open_edit} onClose={this.handleCloseEdite}>
                    <Modal.Header>Editar Pago</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form>
                                <Form.Select placeholder='Forma de Pago' label='Forma de Pago'
                                             options={c.PAYMENT_TYPES} value={this.state.data.type}
                                             onChange={(e, {value}) => this.handlePaymentTypeChange(value)}/>
                                <Form.Input
                                    label='Valor Recibido'
                                    error={this.state.payment_error}
                                    children={
                                        <MaskedInput
                                            mask={moneyMask}
                                            autoFocus
                                            placeholder='Valor Recibido'
                                            value={this.state.data.payment}
                                            onChange={this.handlePaymentChange}
                                        />
                                    }
                                />
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='save' labelPosition='left' onClick={this.handleSubmit} loading={this.state.sending_payment} disabled={this.state.sending_payment} primary content="Actualizar"/>
                        <Button icon='x' labelPosition='left' onClick={this.handleCloseEdite} content="Cancelar"/>
                    </Modal.Actions>
                </Modal>

                <QuestionDialog ref="delete_payment" message="Borrar este pago" callbackConfirm={this.deletePayment}/>

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        payments_dialog: state.get('payments_dialog'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        simpleTableDelete(data){
            dispatch(simpleTableDelete(data))
        },
        showToast(data){
            dispatch(showToast(data))
        },
        paymentsDialog(data){
            dispatch(paymentsDialog(data))
        },
        totalSale(data){
            dispatch(totalSale(data))
        },
        simpleTableAddOrUpdate(data){
            dispatch(simpleTableAddOrUpdate(data))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Payments);



// WEBPACK FOOTER //
// ./src/components/sale/Payments.js